import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

// Components
import { LoginComponent } from './non-authenticated modules/login/login.component';
import { ForgetPasswordComponent } from './non-authenticated modules/forget-password/forget-password.component';

// Services
import { CookieService } from 'ngx-cookie-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FirestoreService } from './services/firestore.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { provideFirestore,getFirestore } from '@angular/fire/firestore';
import { MatSnackbarSeverity } from 'mat-snackbar-severity';
import { MaterialModule} from './authenicated modules/materail/materail.module';
import { SortPipe } from './Pipes/sort.pipe';
// import { RemoveElementPipe } from './Pipes/remove-element.pipe';
import { CellRendererComponent } from '../app/authenicated modules/common-coponents/cell-renderer/cell-renderer.component';
import { CommonCoponentsModule } from './authenicated modules/common-coponents/common-coponents.module';

// ag-grid imports
import { AgGridModule } from 'ag-grid-angular';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgetPasswordComponent,
    CellRendererComponent
    // RemoveElementPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonCoponentsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    MaterialModule,
    AgGridModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    // NgbModule
  ],
  providers: [CookieService,
    MatSnackbarSeverity,
  HttpClient,
  SortPipe,
FirestoreService],
  bootstrap: [AppComponent]
})
export class AppModule { }
